/**
 * Prints project info to the console (version, environment, etc.)
 */
import { environment } from "../constants";
import pkg from "../../package.json";

export function printProjectInfo() {
  const info = {
    version: pkg.version,
    environment,
  };

  console.log(
    `%c ${JSON.stringify(info)}`,
    "background: #222; color: #bada55; font-size: 12px; padding: 4px 8px; border-radius: 4px;"
  );
}
